/**
 * Where the auth token lives.
 *
 * Two storages on purpose:
 *
 *   localStorage    your own sign-in. Shared by every tab, survives restarts.
 *   sessionStorage  an impersonated session. Scoped to ONE tab.
 *
 * That split is what lets a super admin open a customer account in a new tab
 * while their platform session keeps working in the original one. localStorage
 * is shared across tabs, so writing the impersonation token there would sign
 * them out of the platform everywhere.
 *
 * sessionStorage wins when both are present — a tab holding an impersonation is
 * acting as that company, whatever the browser-wide login says.
 */
export const TOKEN_KEY = 'recruit_token';

export function getToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;    // private mode or blocked storage
  }
}

/** Your own login — browser-wide. */
export function setPersistentToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch { /* nothing we can do; the session just will not survive a reload */ }
}

/** An impersonation — this tab only. */
export function setTabToken(token) {
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
  } catch { /* as above */ }
}

/** True if THIS tab is impersonating, regardless of the browser-wide login. */
export function isTabImpersonating() {
  try {
    return Boolean(sessionStorage.getItem(TOKEN_KEY));
  } catch {
    return false;
  }
}

export function clearTokens() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore */ }
}
